"use strict";

export function initInScope ($scope) {
    let $googleEmbedMap = $scope.find('.js-google-embed-map'),
        address = $googleEmbedMap.data('address').split('&').join('+').split(' ').join('+');

    $googleEmbedMap.attr('src', 'https://www.google.com/maps/embed/v1/place?key=' + _config.googleMapAPIKey + '&q='+ address);
}